import dayjs from 'dayjs';
import fromPairs from 'lodash/fromPairs';
import toPairs from 'lodash/toPairs';

export const parseTimestamps = (item) =>
  fromPairs(
    toPairs(item).map(([key, value]) => [
      key,
      key.match(/At$/) && value ? dayjs.utc(value) : value,
    ]),
  );
